export const SEARCH_SAVE = 'SEARCH_SAVE';
export const CLEAR_RECENT = 'SEARCH_CLEAR_RECENT';
export const ENTER_SEARCH_MENU = 'ENTER_SEARCH_MENU';
export const EXIT_SEARCH_MENU = 'EXIT_SEARCH_MENU';
export const SEARCH_RESULT_CLICK_FULL = 'SEARCH_RESULT_CLICK_FULL';
export const SEARCH_RESULT_CLICK_MENU = 'SEARCH_RESULT_CLICK_MENU';
export const SEARCH_INPUT_QUERY = 'SEARCH_INPUT_QUERY';
export const SUGGESTION_CLICK = 'SUGGESTION_CLICK';
export const SEARCH_CLICK = 'SEARCH_CLICK';
export const SEARCH_FOCUS = 'SEARCH_FOCUS';
export const SEARCH_BLUR = 'SEARCH_BLUR';
export const SEARCH_FILTER = 'SEARCH_FILTER';
export const SEARCH_SORT = 'SEARCH_SORT';
export const SEARCH_SUBMIT_FEEDBACK = 'SEARCH_SUBMIT_FEEDBACK';

const searchSave = query => ({ type: SEARCH_SAVE, query });
const clearRecent = content => ({ type: CLEAR_RECENT, content });

const searchSubmitFeedback = (rating, query) => ({
  type: SEARCH_SUBMIT_FEEDBACK,
  rating,
  query,
});

const suggestionClick = (suggestionType, position) => ({
  type: SUGGESTION_CLICK,
  suggestion: suggestionType,
  reciprocalRank: 1 / position,
});

const searchClick = position => ({
  type: SEARCH_CLICK,
  reciprocalRank: 1 / position,
});

const searchFilter = section => ({
  type: SEARCH_FILTER,
  section,
});

const searchSort = sort => ({
  type: SEARCH_SORT,
  sort,
});

const searchFocus = () => ({
  type: SEARCH_FOCUS,
});

const searchBlur = () => ({
  type: SEARCH_BLUR,
});

const searchInstant = (action, query, didYouMean, data = {}) => ({
  type: 'SEARCH_INSTANT',
  action,
  query: [query, didYouMean].filter(x => x).join(' → '),
  ...data,
});

const enterSearchMenu = () => ({
  type: ENTER_SEARCH_MENU,
});

const exitSearchMenu = () => ({
  type: EXIT_SEARCH_MENU,
});

const searchResultClick = actionName => (resultType, item) => ({
  type: actionName,
  data: {
    type: resultType,
    item,
  },
});

const searchInputQuery = query => ({
  type: SEARCH_INPUT_QUERY,
  data: {
    query,
  },
});

export const searchFetchError = error => ({
  type: 'SEARCH_FETCH_ERROR',
  error,
});

export default {
  searchInstant,
  suggestionClick,
  searchClick,
  searchFocus,
  searchBlur,
  searchSave,
  clearRecent,
  enterSearchMenu,
  exitSearchMenu,
  searchResultClick,
  searchInputQuery,
  searchFilter,
  searchSort,
  searchSubmitFeedback,
};
